import React, { useEffect } from "react";
// import Typography from "@mui/material/Typography";
// import ArrowRightIcon from "@mui/icons-material/ArrowRight";
// import { TypeIcon } from "./TypeIcon";
import "./index.scss";
import { useDragOver } from "@minoru/react-dnd-treeview";
import { IconXmark } from "../../../assets/icon";
export const CustomNode = (props) => {
  const { deleteItem } = props;
  const { id } = props.node;
  const indent = props.depth * 24;
  const { node, onToggle, isOpen, hasChild } = props;
  const dragOverProps = useDragOver(id, props.onToggle);
  const handleToggle = (e) => {
    e.stopPropagation();
    props.onToggle(props.node.id);
  };
  useEffect(() => {
    if (hasChild) {
      onToggle(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasChild, id]);

  return (
    <div
      className={`tree-node`}
      onClick={handleToggle}
      style={{
        paddingInlineStart: indent,
        cursor: "pointer",
        display: "flex",
        justifyContent: "space-between",
      }}
      {...dragOverProps}
    >
      <div className={"labelGridItem"}>
        {" "}
        <img
          src={`${window.SERVER_URL}/${props.node.icon}`}
          alt="Icon"
          className="css-icon"
          style={{ marginRight: "1.5rem" }}
        />
        {props.node.text}
      </div>
      <IconXmark onClick={() => deleteItem(id)} />
    </div>
  );
};
